"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagState = exports.TagFetchState = exports.PAGE_SIZE = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const i18n_1 = require("../i18n");
const tag_map_state_1 = require("../modules/tag.map/tag.map.state");
const services_1 = require("../services");
const mobx_2 = require("../state/mobx");
const page_state_1 = require("../state/page.state");
const tag_sort_state_1 = require("../state/tag.sort.state");
const store_1 = require("../store");
const tag_edit_state_1 = require("./tag.edit.state");
exports.PAGE_SIZE = 22;
var TagFetchState;
(function (TagFetchState) {
    TagFetchState["UNKNOWN"] = "UNKNOWN";
    TagFetchState["HAS_TAGS"] = "HAS_TAGS";
    TagFetchState["NO_TAGS"] = "NO_TAGS";
    TagFetchState["EMPTY_TAGS"] = "EMPTY_TAGS";
})(TagFetchState || (exports.TagFetchState = TagFetchState = {}));
class TagState extends mobx_2.MobxState {
    constructor() {
        super();
        this.loadMoreCount = tag_sort_state_1.MAX_TAG_SHOWN;
        this.loaded = false;
        this.map = new tag_map_state_1.TagMapState(this);
        this.edit = new tag_edit_state_1.TagEditState(i18n_1.T.TAG_NAME);
        this.reaction((_) => services_1.Services.Department.current, () => page_state_1.CurrentState.clearSelected());
    }
    destroy() {
        super.destroy();
        this.map.destroy();
    }
    get tags() {
        const tags = [];
        this.loaded = false;
        for (const tag of store_1.AppStore.Tag.all) {
            const tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
            if (tagSummary !== undefined) {
                this.loaded = true;
            }
            if (!tagSummary || tagSummary.revisions.length === 0) {
                continue;
            }
            tags.push(tag);
        }
        if (store_1.AppStore.Tag.all.length === 0 && store_1.AppStore.Tag.fetched) {
            this.loaded = true;
        }
        return tags;
    }
    get filteredTags() {
        if (store_1.AppStore.Tag.all == null) {
            return [];
        }
        const tags = [];
        const shouldCheckFilter = services_1.Services.Search.filterState.hasFilter();
        for (const tag of store_1.AppStore.Tag.all) {
            if (shouldCheckFilter) {
                const filtered = services_1.Services.Search.includesTag(tag) || page_state_1.CurrentState.Tag.isTagSelected(tag.objectId);
                if (!filtered) {
                    continue;
                }
            }
            const tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
            if (tagSummary == null || tagSummary.revisions.length === 0) {
                continue;
            }
            tags.push(tag);
        }
        return tag_sort_state_1.TagSortState.sortTags(tags);
    }
    get fetchState() {
        // Fetching tags and tag summaries
        let tags = this.tags;
        if (!store_1.AppStore.Tag.fetched || !this.loaded) {
            return TagFetchState.UNKNOWN;
        }
        if (store_1.AppStore.Tag.all.length > 0 && this.tags.length === 0 && tags != null) {
            return TagFetchState.EMPTY_TAGS;
        }
        if (this.tags.length > 0) {
            return TagFetchState.HAS_TAGS;
        }
        return TagFetchState.NO_TAGS;
    }
    get visibleTags() {
        const tags = this.filteredTags.length < this.loadMoreCount
            ? this.filteredTags
            : this.filteredTags.slice(0, this.loadMoreCount);
        page_state_1.CurrentState.Tag.setVisibleTagListObjectIDs(tags.map((tag) => tag.objectId));
        return tags;
    }
    get hasMore() {
        return this.filteredTags.length > this.loadMoreCount;
    }
    loadMore() {
        this.loadMoreCount += tag_sort_state_1.MAX_TAG_SHOWN;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Tag:LoadMore', String(this.loadMoreCount), 1);
    }
    expandTag(tag) {
        page_state_1.CurrentState.setExpandedTagId(tag.objectId);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Tag:Expand', tag.objectId, 1);
    }
    collapseTag(tag) {
        page_state_1.CurrentState.setExpandedTagId(null);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Tag:Collapse', tag.objectId, 1);
    }
    get allSelected() {
        for (const tag of this.filteredTags) {
            const tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
            if (tagSummary == null ||
                tagSummary.revisions.length !== page_state_1.CurrentState.Tag.collectionsSelectedSize(tag.objectId)) {
                return false;
            }
        }
        return true;
    }
    inspectHovered() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { hoverId } = page_state_1.CurrentState;
            const canChange = yield this.map.checkChangeCollection(hoverId);
            if (canChange) {
                page_state_1.CurrentState.setInspectedCollection(hoverId);
            }
        });
    }
}
exports.TagState = TagState;
tslib_1.__decorate([
    mobx_1.observable
], TagState.prototype, "loadMoreCount", void 0);
tslib_1.__decorate([
    mobx_1.computed
], TagState.prototype, "tags", null);
tslib_1.__decorate([
    mobx_1.computed
], TagState.prototype, "filteredTags", null);
tslib_1.__decorate([
    mobx_1.computed
], TagState.prototype, "fetchState", null);
tslib_1.__decorate([
    mobx_1.computed
], TagState.prototype, "visibleTags", null);
tslib_1.__decorate([
    mobx_1.computed
], TagState.prototype, "hasMore", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TagState.prototype, "loadMore", null);
tslib_1.__decorate([
    mobx_1.action
], TagState.prototype, "expandTag", null);
tslib_1.__decorate([
    mobx_1.action
], TagState.prototype, "collapseTag", null);
tslib_1.__decorate([
    mobx_1.computed
], TagState.prototype, "allSelected", null);
tslib_1.__decorate([
    mobx_1.action.bound
], TagState.prototype, "inspectHovered", null);
//# sourceMappingURL=tag.state.js.map